import React from 'react';
import { Route } from 'react-router-dom';
import getClientConfig from '../../utils/getClientConfig';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import { SCol, SContainer, SRow } from '@avalara/skylab-sdk/react';
import { FeatureFlagEnum } from '../../utils/enums';

const AvaAppUserManagementNoticeComponent = ({ history }) => {
    const { avaAppUserManagementUrl, featureFlags } = getClientConfig();
    
    // Check if the new tiles feature flag is enabled
    const enableUserManagementTiles = featureFlags?.[FeatureFlagEnum.ENABLE_USER_MANAGEMENT_TILES];

    const redirectToNewPage = () => {
        window.open(avaAppUserManagementUrl, '_blank');
    };

    if (!enableUserManagementTiles) {
        return (
            <div className="content-area" data-testid="ava-app-user-management-component">
                <SContainer>
                    <SRow className="margin-top-none margin-bottom-none">
                        <SCol span="12">
                            <h1 className="margin-bottom-none"><LanguageStringResolver string='TitleUserManagement' /></h1>

                            <p className="margin-bottom-none margin-top-xs"><LanguageStringResolver string='UserManagement_NavigationInfo' /></p>
                            <button className="button primary margin-top-xs" onClick={redirectToNewPage} data-testid="redirect-button">
                                <LanguageStringResolver string='UserManagementRedirectButton' />
                            </button>

                            <h1 className="margin-bottom-none"><LanguageStringResolver string='UserManagement_SubHeading_Roles' /></h1>
                            <p className="margin-top-xs margin-bottom-none">
                                <span className="bold"><LanguageStringResolver string='UserManagement_RolesName_1' /></span>
                                <span><LanguageStringResolver string='UserManagement_RolesInfo_1' /></span>
                            </p>
                            <p className="margin-top-xs">
                                <span className="bold"><LanguageStringResolver string='UserManagement_RolesName_2' /></span>
                                <span><LanguageStringResolver string='UserManagement_RolesInfo_2' /></span>
                            </p>

                            <h1 className="margin-bottom-none"><LanguageStringResolver string='UserManagement_SubHeading_CompanyPermissions' /></h1>
                            <p className="margin-top-xs margin-bottom-none">
                                <LanguageStringResolver string='UserManagement_CompanyPermissionsInfo_1_a' />
                                <span className="bold"><LanguageStringResolver string='UserManagement_CompanyPermissionsInfo_1_b' /></span>
                                <LanguageStringResolver string='UserManagement_CompanyPermissionsInfo_1_c' />
                            </p>
                            <p className="margin-top-xs">
                                <LanguageStringResolver string='UserManagement_CompanyPermissionsInfo_2_a' />
                                <span className="bold"><LanguageStringResolver string='UserManagement_CompanyPermissionsInfo_2_b' /></span>
                            </p>
                        </SCol>
                    </SRow>
                </SContainer>
            </div>
        );
    }

    return (
        <div className="content-area" data-testid="ava-app-user-management-component">
            <SContainer>
                <SRow className="margin-top-none margin-bottom-lg">
                    <SCol span="12">
                        <h1 className="margin-bottom-xs">
                            <LanguageStringResolver string='UserPermissionsManagement_Title' />
                        </h1>
                        <p className="margin-bottom-lg margin-top-xs">
                            <LanguageStringResolver string='UserPermissionsManagement_Description' />
                        </p>
                    </SCol>
                </SRow>

                <SRow className="display-flex user-management-tiles-row">
                    <SCol span="4">
                        <div className="panel p30 margin-right-md margin-bottom-md user-management-card">
                            <h3 className="margin-bottom-xs">
                                <LanguageStringResolver string='UserRoleManagement_Title' />
                            </h3>
                            <p className="margin-bottom-md">
                                <LanguageStringResolver string='UserRoleManagement_Description' />
                            </p>
                            
                            <div className="p15 margin-bottom-md user-management-guidance-box user-management-flex-spacer">
                                <p className="margin-bottom-xs">
                                    <span className="bold"><LanguageStringResolver string='UserRoleManagement_ImportantGuidance' /></span>
                                </p>
                                <p className="margin-bottom-xs">
                                    <span><LanguageStringResolver string='UserRoleManagement_AdminRoleGuidance' /></span>
                                </p>
                                <p className="margin-bottom-xs">
                                    <span><LanguageStringResolver string='UserRoleManagement_PrepareUserGuidance' /></span>
                                </p>
                            </div>

                            <button className="primary" onClick={() => window.open(avaAppUserManagementUrl, '_blank')} data-testid="user-roles-button">
                                <LanguageStringResolver string='UserRoleManagement_Button' />
                            </button>
                        </div>
                    </SCol>

                    <SCol span="4">
                        <div className="panel p30 margin-right-md margin-bottom-md user-management-card">
                            <h3 className="margin-bottom-xs">
                                <LanguageStringResolver string='CompanyPermissions_Title' />
                            </h3>
                            <div className="user-management-flex-spacer">
                                <p className="margin-bottom-lg">
                                    <LanguageStringResolver string='CompanyPermissions_Description' />
                                </p>
                            </div>

                            <button className="primary" onClick={() => history.push('/CompanyPermissions')} data-testid="company-permissions-button">
                                <LanguageStringResolver string='CompanyPermissions_Button' />
                            </button>
                        </div>
                    </SCol>

                    <SCol span="4">
                        <div className="panel p30 margin-bottom-md user-management-card">
                            <h3 className="margin-bottom-xs">
                                <LanguageStringResolver string='DirectSubmissionPermissions_Title' />
                            </h3>
                            <div className="user-management-flex-spacer">
                                <p className="margin-bottom-lg">
                                    <LanguageStringResolver string='DirectSubmissionPermissions_Description' />
                                </p>
                            </div>

                            <button className="primary" onClick={() => history.push('/DirectSubmissionPermissions')} data-testid="submission-permissions-button">
                                <LanguageStringResolver string='DirectSubmissionPermissions_Button' />
                            </button>
                        </div>
                    </SCol>
                </SRow>

                <SRow className="margin-top-lg">
                    <SCol span="12">
                        <s-alert status="info" class="mb30" nodismiss={true} data-testid="admin-access-notice">
                            <div>
                                <strong><LanguageStringResolver string='UserManagement_AdminAccessNotice_Title' /></strong><br />
                                <LanguageStringResolver string='UserManagement_AdminAccessNotice_Description' />
                            </div>
                        </s-alert>
                    </SCol>
                </SRow>
            </SContainer>
        </div>
    );
};

function AvaAppUserManagementNotice() {
    return (
        <Route render={({ history }) => (
            <AvaAppUserManagementNoticeComponent history={history} />
        )} />
    );
}

AvaAppUserManagementNotice.displayName = 'AvaAppUserManagementNotice';

export default AvaAppUserManagementNotice;